import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[GoDo ERP] UI error", error, info.componentStack);
  }

  private handleReload = () => {
    window.location.reload();
  };

  private handleClearAndReload = () => {
    try {
      localStorage.removeItem("godo_token");
      localStorage.removeItem("godo_profile");
    } catch {
      /* ignore */
    }
    window.location.href = "/login";
  };

  render() {
    if (this.state.error) {
      return (
        <div
          dir="rtl"
          className="godo-app-bg flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center"
        >
          <h1 className="text-lg font-bold text-godo-primary">تعذّر تشغيل الواجهة</h1>
          <p className="max-w-md text-sm text-slate-600">
            حدث خطأ في المتصفح. جرّب تحديث الصفحة أو مسح جلسة الدخول المحفوظة.
          </p>
          <p className="max-w-lg break-all text-xs text-red-700">
            {this.state.error.message}
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            <button
              type="button"
              className="godo-btn-primary w-auto px-6"
              onClick={this.handleReload}
            >
              تحديث الصفحة
            </button>
            <button
              type="button"
              className="godo-btn-ghost"
              onClick={this.handleClearAndReload}
            >
              مسح الجلسة والدخول
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
